// checkboxがチェックされてない場合に、アラートを表示する
export default class {
  constructor() {
    document.querySelectorAll('.js-agreement-check').forEach((checkboxElm) => {
      const alertTargetElms = Array.from(document.querySelectorAll(checkboxElm.dataset.alertTarget));

      checkboxElm.addEventListener('input', () => {
        alertTargetElms.forEach((elm) => {
          elm.style.display = checkboxElm.checked ? 'none' : 'block';
        });
      });
    });
  }
}
